import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion } from 'framer-motion';
import { IconCloseCircle } from '../../utils/icons';


interface ModalProps {
	children: React.ReactNode
	domTargetId?: string
	transparent?: boolean
	width?: 'auto' | 'small' | 'medium' |'large'
	fixedHeight?: boolean
	customStyle?: React.CSSProperties
	onClose: ()=>void
}

interface WithChildrenProps {
	children: React.ReactNode
	customStyle?: React.CSSProperties
}

const animation = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	transition: { duration: 0.25, ease: 'easeIn' }
};

const Modal = ({
	children,
	domTargetId,
	transparent,
	width = 'small',
	customStyle,
	fixedHeight,
	onClose
}: ModalProps) => {

	const handleKeypress = (e: KeyboardEvent) => {
		if (e.key === 'Escape') {
			closeModal();
		}
	};

	const closeModal = () => {
		onClose();
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeypress);
		return () => document.removeEventListener('keydown', handleKeypress);
	}, []);

	return createPortal(
		<>
			<motion.div
				className={ `lhp-modal ${transparent ? 'transparent' : ''} ${width} ${fixedHeight ? 'fixed-height' : ''}` }
				style={ customStyle }
				{ ...animation }
			>
				{ !!transparent && (
					<button
						className="btn-close"
						onClick={ ()=>{
							closeModal();
						} }>
						<IconCloseCircle />
					</button>
				) }
				{ !transparent && (
					<button className="btn-close" onClick={ () => closeModal() }>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="5.63574" y="7.05029" width="2" height="16" transform="rotate(-45 5.63574 7.05029)" fill="#92004D" />
							<rect x="16.9497" y="5.63574" width="2" height="16" transform="rotate(45 16.9497 5.63574)" fill="#92004D" />
						</svg>
					</button>
				) }
				{ children }
			</motion.div>
			<div
				className={ 'modal-backdrop' }
				onClick={ ()=>{
					closeModal();
				} } />
		</>,
		document.getElementById(domTargetId || 'portal') as Element
	);
};


Modal.ConsentContainer = function ModalConsent({ children, customStyle }:WithChildrenProps) {
	return <div className="consent-container" style={ customStyle }>{ children }</div>;
};
Modal.Content = function ModalContent({ children, customStyle }:WithChildrenProps) {
	return <div className="modal-content" style={ customStyle }>{ children }</div>;
};
Modal.Footer = function ModalFooter({ children, customStyle }:WithChildrenProps) {
	return <div className="modal-footer" style={ customStyle }>{ children }</div>;
};

export default Modal;